import { render, staticRenderFns } from "./auditorLayout.vue?vue&type=template&id=4877fae5&scoped=true"
import script from "./auditorLayout.vue?vue&type=script&lang=js"
export * from "./auditorLayout.vue?vue&type=script&lang=js"
import style0 from "./auditorLayout.vue?vue&type=style&index=0&id=4877fae5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4877fae5",
  null
  
)

export default component.exports